const NON_TEXT_INPUT_TYPES = new Set(["button", "checkbox", "color", "file", "hidden", "image", "radio", "range", "reset", "submit"]);

type FocusedElement = {
    tagName?: string;
    type?: string;
    isContentEditable?: boolean;
} | null;

// True while an element is focused that opens the on-screen keyboard (iOS may scroll the document to keep it visible).
export function isTextInputFocused(focusedElement: FocusedElement): boolean {
    if (!focusedElement) return false;
    if (focusedElement.isContentEditable) return true;

    const tagName = focusedElement.tagName?.toUpperCase();
    if (tagName === "TEXTAREA") return true;
    if (tagName !== "INPUT") return false;

    return !NON_TEXT_INPUT_TYPES.has((focusedElement.type ?? "text").toLowerCase());
}

// The document should always stay at 0/0; only while typing iOS may move it to keep the input visible.
export function shouldResetDocumentScroll(scrollX: number, scrollY: number, focusedElement: FocusedElement): boolean {
    if (scrollX === 0 && scrollY === 0) return false;
    return !isTextInputFocused(focusedElement);
}
